module.exports = __webpack_public_path__ + "img/1.506a7317.png";